import { render, staticRenderFns } from "./competencies-list-panel.vue?vue&type=template&id=42463c3f&scoped=true"
import script from "./competencies-list-panel.ts?vue&type=script&lang=ts&external"
export * from "./competencies-list-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./competencies-list-panel.scss?vue&type=style&index=0&id=42463c3f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42463c3f",
  null
  
)

export default component.exports